export default {
  appTitle: 'Web de proveedores',
  title: 'Autorizaciones',
  filterLabel: 'Filtrar por',
  orderLabel: 'Ordenar por',
  authorizationTabLabel: 'Autorizaciones',
  loadingDataLabel: 'Obteniendo autorizaciones',
  emptyDataLabel: 'No se encontraron resultados',
  tryAgainLabel: 'Intente buscando otro término o ',
  paginationSizeLabel: 'Resultados/página',
  addAuthorization: 'Nueva autorización',
  addAuthorizationShortLabel: 'Nueva',
  resultLabel: '{result} resultado | {result} resultados',
  lastUpdateLabel: 'Última actualización: {datetime}',
  cleanFilters: 'limpiando los filtros',
  filtersAppliedLabel: ' aplicados',
  documentation: {
    complete: "Completo",
    incomplete: "({uploaded}/{total}) Docs"
  },
  createAuthorization: {
    success: 'La autorización fue creada exitosamente.',
    error: 'Ocurrió un error en la creación de la autorización.'
  },
  filters: {
    status: 'Estado',
    from: 'Desde',
    to: 'Hasta',
    dateRange: 'Rango de fechas',
    searchCode: 'Buscar autorización o reclamo',
    satisfiesDocumentsPolicy: 'Documentación'
  },
  order: {
    createdAt: 'Fecha de creación',
    beneficiaryName: 'Nombre de asegurado (a-z)',
    coverageType: 'Cobertura (a-z)',
    status: 'Estado'
  },
  authorizationGrid: {
    claimId: 'Reclamo',
    authorizationCode: "Autorización",
    code: 'ID Autorización',
    createdAt: 'Fecha de creación',
    sponsor: 'Aseguradora',
    beneficiary: 'Asegurado/a',
    memberCode: 'Carnet',
    authorizationType: 'Tipo de autorización',
    documentation: "Documentación",
    status: 'Estado',
    providerBranchName: 'Sucursal'
  },
  status: {
    error: {
      title: 'Error',
      description: 'Algo dentro de la autorización salió mal'
    },
    paid: {
      title: 'Pagado',
      description: 'Autorización pagada'
    },
    voided: {
      title: 'Deshabilitado',
      description: 'Autorizacion anulada'
    },
    expired: {
      title: 'Expirado',
      description: 'El tiempo de vida de la autorización ha concluído'
    },
    canceled: {
      title: 'Cancelado',
      description: 'Autorización cancelada'
    },
    completed: {
      title: 'Completado',
      description: 'La autorización se completó correctamente'
    },
    inProgress: {
      title: 'En progreso',
      description: 'Se están llevando a cabo procesos para completar la autorización'
    },
    failed: {
      title: 'Fallido',
      description: 'No se pudo llevar a cabo la autorización'
    },
    ready: {
      title: 'Listo',
      description: 'La autorización se efectuó correctamente'
    },
    expirationInProgress: {
      title: 'Expiración en proceso',
      description: 'Se están llevando a cabo procesos para expirar la autorización'
    },
    updateInProgress: {
      title: 'Actualización en proceso',
      description: 'Se están llevando a cabo procesos para actualizar la autorización'
    }
  },
  statusDescription: {
    title: "Filtrar por estados",
    apply: "Aplicar"
  },
  types: {
    pharmacy: 'Farmacia',
    process: 'Procedimiento',
    prescriptionDrugs: 'Medicamentos',
    diagnosticTest: 'Pruebas de diagnóstico',
    sports: 'Deportes',
    wellness: 'Gastos medicos',
    education: 'Educación',
    creditCardBalance: 'Saldo deudor',
    occupationalHazard: 'Riesgo laboral'
  },
  tabs: {
    authorizations: 'Autorizaciones',
    NewAuthorization: 'Nueva autorización',
    settlements: 'Radicaciones',
    newSettlement: 'Nueva radicación'
  },
  actions: {
    void: 'Anular',
    voidOnlyClaim: 'Anular reclamo'
  },
  satisfiesDocumentsPolicy: {
    complete: 'Completa',
    incomplete: 'Incompleta'
  }
}
